module.exports = __webpack_public_path__ + "img/shareIcon.7c57fc71.png";